import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

import { useAdmin } from '@/_providers/administration';

import { Container } from '../layout/containers';

export function PageHeader({
  className,
  children,
  isModal,
}: PropsWithChildren<{ className?: string; isModal?: boolean }>) {
  const widthCtrl = useAdmin();
  return (
    <Container
      className={twMerge('mt-0 pt-6 pb-4', widthCtrl[0].isFullWidth || isModal ? '3xl:max-w-480 4xl:max-w-480' : '')}
    >
      <header
        className={twMerge(
          'flex w-full flex-col gap-y-2 px-2 pb-0 sm:flex-row sm:items-center sm:justify-between sm:gap-y-0',
          className
        )}
      >
        {children}
      </header>
    </Container>
  );
}
